import type { CSSProperties } from 'react'
import Box from '@mui/material/Box'
import RadioGroup from '@mui/material/RadioGroup'

import {
  type TimeData,
  DEFAULT_AT,
  DEFAULT_DURATION,
  INIT_STATE,
} from './_shared/constants'
import getTimeNodeData from './utils/getTimeNodeData'
import getTimeNodeType from './utils/getTimeNodeType'
import AdvDate from './AdvDate'
import AdvWeekday from './AdvWeekday'
import Duration from './Duration'

type Props = {
  defaultTimeData?: TimeData
  direction?: CSSProperties['flexDirection']
  isEditable: boolean
  isError?: boolean
  isHideDateHourAndMinute?: boolean
  isHideDurationHourAndMinute?: boolean
  isHideWeekdayHourAndMinute?: boolean
  mb?: number
  minAdvDate?: Date
  onTimeDataChange: (timeData: TimeData) => void
  timeData?: TimeData
}

export const Timing = ({
  defaultTimeData = INIT_STATE.timeData,
  direction = 'row',
  isEditable,
  isError,
  isHideDateHourAndMinute = false,
  isHideDurationHourAndMinute = false,
  isHideWeekdayHourAndMinute = false,
  mb = 4,
  minAdvDate = new Date(),
  onTimeDataChange,
  timeData = defaultTimeData,
}: Props) => {
  const timeNodeType = getTimeNodeType(timeData)

  const handleTimeDataUpdate = (newTimeData: TimeData) => {
    onTimeDataChange(getTimeNodeData(getTimeNodeType(newTimeData), newTimeData))
  }

  return (
    <Box mb={mb} width="100%">
      <RadioGroup name="timeNodeType" value={timeNodeType}>
        <Box display="flex" flexDirection={direction} width="100%">
          <Duration
            isError={isError}
            isEditable={isEditable}
            isColumnEditable={timeNodeType === 'duration'}
            isHideHourAndMinute={isHideDurationHourAndMinute}
            timeData={timeData}
            // 目前只有 duration 需要有不同預設值。
            defaultData={{
              duration: defaultTimeData?.duration || DEFAULT_DURATION,
            }}
            onTimeDataUpdate={handleTimeDataUpdate}
          />
        </Box>
        <Box mt={2} display="flex" flexDirection={direction} width="100%">
          <AdvDate
            isError={isError}
            isEditable={isEditable}
            isColumnEditable={timeNodeType === 'specifiedDay'}
            isHideHourAndMinute={isHideDateHourAndMinute}
            timeData={
              timeNodeType === 'specifiedDay'
                ? timeData
                : // 顯示預設值
                  { at: DEFAULT_AT }
            }
            onTimeDataUpdate={handleTimeDataUpdate}
            minDate={minAdvDate}
          />
        </Box>
        <Box mt={2} display="flex" flexDirection={direction} width="100%">
          <AdvWeekday
            isError={isError}
            isEditable={isEditable}
            isColumnEditable={timeNodeType === 'dayOfWeek'}
            isHideHourAndMinute={isHideWeekdayHourAndMinute}
            timeData={
              timeNodeType === 'dayOfWeek'
                ? timeData
                : // 顯示預設值
                  { at: DEFAULT_AT }
            }
            onTimeDataUpdate={handleTimeDataUpdate}
          />
        </Box>
      </RadioGroup>
    </Box>
  )
}

export default Timing
